
import FormSelect from "@/components/main/forms/FormSelect";
import PricingTabButtons from "@/components/main/pricing/PricingTabButtons"


import DatingTab from "@/components/main/pricing/content/DatingTab";

import SocialTab from "@/components/main/pricing/content/SocialTab";
import ListingLocatorTab from "@/components/main/pricing/content/ListingLocatorTab";
import CamStreamsTab from "@/components/main/pricing/content/CamStreamsTab";
import XXXTab from "@/components/main/pricing/content/XXXTab";
import TinderTab from "@/components/main/pricing/content/TinderTab";

import RedHeadBox from "@/components/main/core/RedHeadBox";

import TinderTabMob from "@/components/main/pricing/contentMob/TinderTabMob";
import DatingTabMob from "@/components/main/pricing/contentMob/DatingTabMob";
import SocialTabMob from "@/components/main/pricing/contentMob/SocialTabMob";
import ListingLocatorTabMob from "@/components/main/pricing/contentMob/ListingLocatorTabMob";
import CamStreamsTabMob from "@/components/main/pricing/contentMob/CamStreamsTabMob";
import XXXTabMob from "@/components/main/pricing/contentMob/XXXTabMob";
import TabsButtons from "@/components/main/tabs/TabsButtons";



export default {
  name: "PricingSection",
  components: {
    TabsButtons, FormSelect, TinderTab, RedHeadBox, PricingTabButtons, DatingTab, SocialTab, ListingLocatorTab, CamStreamsTab, XXXTab,
    TinderTabMob, DatingTabMob, SocialTabMob, ListingLocatorTabMob, CamStreamsTabMob, XXXTabMob,   },
  data() {
    return {
      currentTab: 1,
      currentTabMob: 1,
      products: [
        {
          name: 'DATING/ALTERNATIVE LIFESTYLES SITES',
          id: 1
        },
        {
          name: 'SOCIAL MEDIA & MOBILE CHAT/HOOK-UP APPS',
          id: 2
        },
        {
          name: 'LISTING LOCATOR',
          id: 3
        },
        {
          name: 'LIVE ADULT STREAMS',
          id: 4
        },
        {
          name: 'XXX WEBSITES',
          id: 5
        },
        {
          name: 'TINDER BLASTER',
          id: 6
        }
      ]
    }
  },
  props:['title'],
  methods: {
    change(data) {
      this.currentTab = data
    },
    makeChoice(id) {
      this.currentTabMob = id
    }
  },

}
